import { string, object } from "yup";

export const loginValidationSchema = object().shape({
    email: string().email("Email is not valid").required("Email is required"),
    password: string().required("Password is required").min(6, "Password must be at least 6 characters"),
});
